import React from "react";
import { IPath, PATH } from "../../router/path";
import { ReactElement } from "react";
import {
  ContactIcon,
  ContainerOverviewIcon,
  AddContainerIcon,
  LocationOverviewIcon,
  CommoditiesIcon,
} from "../../assets/custom-icons";
import {
  ViewHeadline,
  PermIdentity,
  EventAvailable,
  RateReview,
  ImportExport,
  Bookmark,
  CloudUpload,
  FaceOutlined,
  Category,
  ArtTrack,
  GroupWork,
} from "@mui/icons-material";
import SvgIcon from "@mui/material/SvgIcon";
import MapIcon from "@mui/icons-material/Map";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";

import AppsIcon from "@mui/icons-material/Apps";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import ArchitectureIcon from "@mui/icons-material/Architecture";
import SourceIcon from "@mui/icons-material/Source";
import { UserRole } from "../../models/types/graphql-global-types";
export interface IMenuItem extends IPath {
  title: string;
  icon: ReactElement;
  action?: boolean;
}

const iconStyle = {
  color: "white",
  height: 20,
  width: 20,
};

export const menuItems: IMenuItem[] = [
  {
    ...PATH.SIMPLE_CATALOG,
    title: "navigation.home",
    icon: <AppsIcon style={iconStyle} />,
    roles: [
      UserRole.ADMIN,
      UserRole.GUEST,
      UserRole.UNDEFINED,
      UserRole.READ_ONLY,
    ],
  },
  {
    ...PATH.CATALOG,
    title: "navigation.adminHome",
    icon: <AppsIcon style={iconStyle} />,
    roles: [UserRole.ADMIN],
  },
  {
    ...PATH.DIGIDO,
    title: "navigation.digido",
    icon: <AppsIcon style={iconStyle} />,
    roles: [UserRole.ADMIN, UserRole.DIGIDO],
  },
  {
    ...PATH.INFO,
    title: "navigation.info",
    icon: <FormatListNumberedIcon style={iconStyle} />,
    roles: [UserRole.ADMIN],
  },
  {
    ...PATH.ARCHITECTURE,
    title: "navigation.architecture",
    icon: <ArchitectureIcon style={iconStyle} />,
    roles: [UserRole.ADMIN],
  },
  {
    ...PATH.CENTRALGATEWAY,
    title: "navigation.central",
    icon: <SourceIcon style={iconStyle} />,
    roles: [UserRole.ADMIN],
  },
  {
    ...PATH.EXTERNALGATEWAY,
    title: "navigation.external",
    icon: <SourceIcon style={iconStyle} />,
    roles: [UserRole.ADMIN],
  },
  {
    ...PATH.ATGOLORSDATAAPI,
    title: "navigation.atgolorsdataapi",
    icon: <SourceIcon style={iconStyle} />,
    roles: [UserRole.ADMIN],
  },
  {
    ...PATH.HANDELSAPP,
    title: "navigation.handelsapp",
    icon: <SourceIcon style={iconStyle} />,
    roles: [UserRole.ADMIN],
  },
  {
    ...PATH.AZURE,
    title: "navigation.azure",
    icon: <SourceIcon style={iconStyle} />,
    roles: [UserRole.ADMIN],
  },
  {
    ...PATH.AUTH,
    title: "navigation.auth",
    icon: <MapIcon style={iconStyle} />,
    roles: [UserRole.ADMIN],
  },
];
